import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useLocation } from 'react-router-dom';
import { Title } from '@/components/Typography';
import { useEwaJdsD86Context } from '../context';

interface HandleTitleParams {
	isEwa: boolean;
	isReview: boolean;
}

export function Header() {
	const { isEwa } = useEwaJdsD86Context();
	const isReview = useLocation().pathname.includes('review');

	function handleTitle({ isEwa, isReview }: HandleTitleParams): string {
		if (isEwa) {
			return I18n.get('Preliminary Ergonomic Analysis') + ' | ' + I18n.get('ISO 20646 + JDS-D86');
		}

		if (isReview) {
			return I18n.get('Ergonomic revaluation') + ' JDS-D86';
		}

		return I18n.get('Evaluation') + ' JDS-D86';
	}

	const title = handleTitle({ isEwa, isReview });

	return (
		<Row justify="center" style={{ marginTop: '1rem' }}>
			<Col>
				<Title level={2}>{title}</Title>
			</Col>
		</Row>
	);
}
